import React, { useEffect, useState, useRef } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
    OPEN_CHATS,
    OPEN_PROJECTS,
    OPEN_BOTTOM_PROJECTS,
    OPEN_BOTTOM_CHATS,
    SET_JOIN_REQUEST_EXTERNAL,
    SET_JOIN_REQUEST_INTERNAL,
    SET_COMPANY_IMAGE,
    SET_COMPANY_ID,
    TOGGLE_PROJECT,
    RIGHT_TOP,
    SET_OPEN_SIDE_BAR,
    TOGGLE_CHAT,
    UPDATE_PROJECT_ACTION_FIRE,
    SET_IN_ACTIVITY,
    TOGGLE_LATEST_MSG,
    TOGGLE_WORK_AREA,
    SET_DEEPLINK_DATA,
    SET_DEEPLINK_LOADING,
    FROM_FROROIEGN_PROFILE,
    SET_CHAT_FULLSCREEN
} from '../store';
import { callAPI } from '../helper/apiUtils';
import { $crud } from '../helper/CrudFactory';
import { DE } from '../Languages/DE';
import { EN } from '../Languages/EN';
import LanguageContext from '../helper/LanguageContext';
import { useContext } from 'react';
import { captureIncomingDeeplink } from '../utils/startupScreen';

function DeeplinkHandler() {
    const location = useLocation();
    const history = useHistory();
    const dispatch = useDispatch();
    const { isGerm, strings } = useContext(LanguageContext);
    const [loadingText, setLoadingText] = useState('');
    const userLoginToken = useSelector(state => state.userLoginToken);
    const isLoading = useSelector(state => state.deeplinkLoading);
    const processedSearchRef = useRef(null);

    useEffect(() => {
        if (processedSearchRef.current === location.search) return;

        const handleDeeplink = async () => {
            captureIncomingDeeplink();
            // Unauthenticated visits must not rewrite /deeplink or open chats
            // (401 logout + startup-screen redirect were dropping the path).
            if (!userLoginToken) {
                dispatch({ type: SET_DEEPLINK_LOADING, loading: false });
                return;
            }

            const searchParams = new URLSearchParams(location.search);
            const chatGroupId = searchParams.get('chatGroupId');
            const roomId = searchParams.get('roomId');
            const companyId = searchParams.get('companyId');
            const messageId = searchParams.get('messageId');
            const page_no = searchParams.get('page_no') || searchParams.get('page');
            
            // Determine if internal based on companyId presence
            const isInternal = !!companyId;
            dispatch({ type: SET_DEEPLINK_LOADING, loading: true, isInternal: isInternal });
            console.log('chatGroupId', chatGroupId)
            console.log('roomId', roomId)

            if (!chatGroupId) {
                $crud.notify({
                    type: 'error',
                    message: strings.invalid_deeplink
                });
                dispatch({ type: SET_DEEPLINK_LOADING, loading: false });
                history.replace('/articles');
                return;
            }

            processedSearchRef.current = location.search;

            try {
                if (roomId && chatGroupId && !companyId) {
                    dispatch({ type: SET_DEEPLINK_DATA, payload: null });
                    dispatch({ type: TOGGLE_LATEST_MSG, payload: false });
                    dispatch({ type: TOGGLE_PROJECT, payload: false });
                    dispatch({ type: OPEN_PROJECTS, openProjects: [] });
                    dispatch({ type: OPEN_CHATS, openChats: [] });
                    dispatch({ type: UPDATE_PROJECT_ACTION_FIRE, updateProjectActionFire: true });
                    dispatch({ type: SET_IN_ACTIVITY, payload: false });
                    dispatch({ type: TOGGLE_WORK_AREA, toggleWorkArea: true });
                    dispatch({ type: SET_DEEPLINK_DATA, payload: { chatGroupId, roomId, messageId, page_no, isInternal: false } });
                    setLoadingText(strings.loading_room);
                    setTimeout(() => {
                        dispatch({ type: SET_OPEN_SIDE_BAR, payload: 'project1' });
                        dispatch({ type: RIGHT_TOP, rightTop: 'project1' });
                    }, 500);
                }
                else if (companyId) {
                    dispatch({ type: SET_DEEPLINK_DATA, payload: null });
                    dispatch({ type: TOGGLE_LATEST_MSG, payload: false });
                    dispatch({ type: TOGGLE_PROJECT, payload: false });
                    dispatch({ type: OPEN_PROJECTS, openProjects: [] });
                    dispatch({ type: OPEN_CHATS, openChats: [] });
                    dispatch({ type: UPDATE_PROJECT_ACTION_FIRE, updateProjectActionFire: true });
                    dispatch({ type: SET_IN_ACTIVITY, payload: false });
                    dispatch({ type: TOGGLE_WORK_AREA, toggleWorkArea: true });
                    dispatch({ type: SET_DEEPLINK_DATA, payload: { chatGroupId, roomId, messageId, page_no, isInternal: true, companyId } });
                    setLoadingText(strings.loading_room);
                    setTimeout(() => {
                        dispatch({ type: SET_OPEN_SIDE_BAR, payload: 'project1' });
                        dispatch({ type: RIGHT_TOP, rightTop: 'project1' });
                    }, 500);
                }
                else if (chatGroupId) {
                    dispatch({ type: SET_DEEPLINK_DATA, payload: null });
                    dispatch({ type: TOGGLE_CHAT, payload: false })
                    dispatch({ type: TOGGLE_LATEST_MSG, payload: false });
                    dispatch({ type: TOGGLE_PROJECT, payload: false });
                    dispatch({ type: OPEN_PROJECTS, openProjects: [] });
                    dispatch({ type: OPEN_CHATS, openChats: [] });
                    dispatch({ type: SET_IN_ACTIVITY, payload: false });
                    dispatch({ type: TOGGLE_WORK_AREA, toggleWorkArea: true });
                    dispatch({ type: SET_CHAT_FULLSCREEN, payload: true });
                    dispatch({ type: SET_DEEPLINK_DATA, payload: { chatGroupId, messageId, page_no } });
                    setLoadingText(strings.loading_chat);
                    requestAnimationFrame(() => {
                        dispatch({ type: FROM_FROROIEGN_PROFILE, payload: 'pageLoad' });
                        dispatch({ type: SET_OPEN_SIDE_BAR, payload: 'chat1' });
                        dispatch({ type: RIGHT_TOP, rightTop: 'chat1' });
                    });
                }
            } catch (error) {
                console.log('error', error)
                dispatch({ type: SET_DEEPLINK_LOADING, loading: false });
            }
        };

        handleDeeplink();
    }, [location, history, dispatch, isGerm, userLoginToken]);

    return null;
}

export default DeeplinkHandler; 